import { ExternalSystemValidationResult } from "../document";

export class ExternalSystemValidationRequestResult {
  constructor(
    public isOk: boolean,
    public message: string,
    public result: ExternalSystemValidationResult,
  ) {}
}
